import React from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';
import '../../css/pdf.css';

const AlldataContainer = () => {
    const { statementDocument } = useSelector((state) => state.voyage);
    const { brief_details = {} } = statementDocument || {};
    const { offhire_data = {} } = statementDocument || {};
    const offhireDataLength = offhire_data?.consumption?.length || 1;

    const formatDate = (date) => {
        console.log(date)
        if(!date){
        const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        };
        return new Date(date).toLocaleString('en-US', options).replace(',', '');
        }else {
            return '-'
        }
    };


    const nestedTableData = [
        {
            key: '1',
            offHire: offhire_data && Object.keys(offhire_data).length > 0 ? 'Yes' : 'No',
            startDate: offhire_data?.start_date && formatDate(offhire_data?.start_date) || '-',
            endDate: offhire_data?.end_date && formatDate(offhire_data?.end_date) || '-',
            fuels: offhire_data?.consumption
            ? offhire_data.consumption.map((data) => ({
                  fuelType: data?.fuel_name, 
                  consumption: data?.consumption,
                  emission: data?.total_co2_emission,
              }))
            : [],
            euaOwnersAccount: offhire_data?.total_eua,
        },
    ];

    const nestedTableColumns = [
    {
        title: 'Off-hire',
        dataIndex: 'offHire',
        key: 'offHire',
        render: (text, record, index) => ({
            children: text,
            props: {
                rowSpan: index === 0 ? offhireDataLength : 0, // Span only the first row for each group
            },
        }),
    },
    {
        title: 'Start Date & Time (UTC)',
        dataIndex: 'startDate',
        key: 'startDate',
        render: (text, record, index) => ({
            children: text,
            props: {
                rowSpan: index === 0 ? offhireDataLength : 0,
            },
        }),
    },
    {
        title: 'End Date & Time (UTC)',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record, index) => ({
            children: text,
            props: {
                rowSpan: index === 0 ? offhireDataLength : 0,
            },
        }),
    },
    {
        title: 'Fuel Type',
        dataIndex: 'fuelType',
        key: 'fuelType',
    },
    {
        title: 'Total Consumption (MT)',
        dataIndex: 'consumption',
        key: 'consumption',
    },
    {
        title: 'Total Emission (CO2 Eq) MT',
        dataIndex: 'emission',
        key: 'emission',
    },
    {
        title: 'EUA on Owners Account',
        dataIndex: 'euaOwnersAccount',
        key: 'euaOwnersAccount',
        render: (text, record, index) => ({
            children: text,
            props: {
                rowSpan: index === 0 ? offhireDataLength : 0,
            },
        }),
    },
];

    


    const renderNestedTable = () => {

        const expandedData = nestedTableData.flatMap((record) =>
            record.fuels.map((fuel, index) => ({
                ...fuel,
                key: `${record.key}-${index}`,
                offHire: index === 0 ? record.offHire : '',
                startDate: index === 0 ? record.startDate : '',
                endDate: index === 0 ? record.endDate : '',
                euaOwnersAccount: index === 0 ? record.euaOwnersAccount : '',
            }))
        );

        return (
            <Table
                columns={nestedTableColumns}
                dataSource={expandedData}
                pagination={false}
                // bordered
                className="nested-table-offhire" 
            />
        );
    };

    const renderRow = (cells, rowIndex) => {
        if (rowIndex === 2) {
            return (
                <tr key={rowIndex} className="ant-table-row">
                    <td colSpan={10} className="ant-table-cell-offhire" >
                        {renderNestedTable()}
                    </td>
                </tr>
            );
        } else {
            return (
                <tr key={rowIndex} className="ant-table-row">
                    {cells.map((cell, cellIndex) => (
                        <td
                            key={cellIndex}
                            colSpan={cell.colSpan}
                            className={`ant-table-cell ${cell.className || ''}`}
                        >
                            {cell.value}
                        </td>
                    ))}
                </tr>
            )
        }
    };



    const expandedRowRender = () => (
        <>
            {renderRow([
                { value: 'Voyage Type', colSpan: 2, className: 'sb-background' },
                { value: 'Applicable Tax %', colSpan: 1, className: 'sb-background' },
                { value: 'Total CO₂ Emitted (MT)', colSpan: 2, className: 'sb-background' },
                { value: 'CO₂ Emission Applicable under EUETS (MT)', colSpan: 2, className: 'sb-background' },
                { value: 'EUA', colSpan: 1, className: 'sb-background' }
            ], 0)}
            {renderRow([
                { value: brief_details.voyage_type || 'N/A', colSpan: 2 },
                { value: brief_details?.tax_percentage?.toFixed(2) || 'N/A', colSpan: 1 },
                { value: brief_details.total_co2_emitted?.toFixed(2) || 'N/A', colSpan: 2 },
                { value: brief_details.co2_emissions_ets?.toFixed(2) || 'N/A', colSpan: 2 },
                { value: brief_details.total_eua?.toFixed(2) || 'N/A', colSpan: 1 }
            ], 1)}
            { Object.keys(offhire_data).length > 0 && renderRow([
                { value: "", colSpan: 8 }
            ], 3)}
            {Object.keys(offhire_data).length > 0 && renderRow([
                { value: "", colSpan: 8 }
            ], 2)}
            {renderRow([
                { value: "", colSpan: 8 }
            ], 3)}
            {renderRow([
                { value: "Total EUA's", colSpan: 2, className: 'sb-background highlighted-tab' },
                { value: brief_details.total_eua?.toFixed(2), colSpan: 3 },
                { value: 'EUA Excluding Off-hire', colSpan: 2, className: 'sb-background' },
                { value: brief_details.eua_excluding_offhire?.toFixed(2) || 'N/A', colSpan: 1 }
            ], 4)}
            {renderRow([
                { value: "", colSpan: 8 }
            ], 5)}
            {renderRow([
                { value: 'WTW', colSpan: 2, className: 'sb-background' },
                { value: 'GHG Intensity', colSpan: 1, className: 'sb-background' },
                { value: 'Compliance Balance', colSpan: 2, className: 'sb-background' },
                { value: 'FEUM Penalty', colSpan: 2, className: 'sb-background highlighted-tab' },
                { value: 'Off hire penalty', colSpan: 1, className: 'sb-background' },
            ], 6)}
            {renderRow([
                { value: `${brief_details.wtw?.toFixed(2) || 'N/A'} MT` || 'N/A', colSpan: 2 },
                { value: `${brief_details.ghg?.toFixed(2) || 'N/A'} gCO₂/MJ` || 'N/A', colSpan: 1 },
                { value: `${brief_details.compliance_balance?.toFixed(2) || 'N/A'} gCO₂eq` || 'N/A', colSpan: 2 },
                { value: `€${brief_details.penalty?.toFixed(2) || 'N/A'}` || 'N/A', colSpan: 2 },
                { value: `€${offhire_data.penalty?.toFixed(2) || '0'}` || 'N/A', colSpan: 1 },
            ], 7)}
        </>
    );

    return (<>
        <Table
            columns={[]}
            dataSource={[]}
            pagination={false}
            bordered
            showHeader={false}
            className='all-data-container-table'
            rowClassName={() => 'custom-row'}
            components={{
                body: {
                    wrapper: ({ children, ...props }) => (
                        <tbody {...props}>
                            {children}
                            {expandedRowRender()}
                        </tbody>
                    )
                }
            }}
        />
    </>
    );
}

export default AlldataContainer;
